import Component from "../../component";

export const PageNavConfig = {
    signature: 'pageNav',
    baseHtmlClass: 'page_nav',
    selector: '.page_nav',
    initedHtmlClassModifier: 'inited',
    datasetConfigKey: 'page_nav',
    identifierDatasetConfigKey: 'identifier',
};

export class PageNav extends Component {

    static applyToAll() {
        document.querySelectorAll(PageNavConfig.selector).forEach((element) => {
            if (!PageNav.isElementComponentized(element, PageNavConfig.signature)) new PageNav(element);
        });
    }

    constructor(id_or_element, props = {}) {
        super({
            element: id_or_element,
            config: PageNavConfig
        });

        this.setDatasetConfig(PageNavConfig.datasetConfigKey);

        this.links = this.element.querySelectorAll('a');
        this.links.forEach((link)=>{
            const linkTarget = new URL(link.href).hash;
            const targetElement = document.querySelector(linkTarget);
            if (targetElement) {
                link.addEventListener('click', (event)=>{
                    event.preventDefault();
                    targetElement.scrollIntoView({behavior:'smooth'});
                })
            }
        });
    }
    

    render() {
    }


}
